import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';
import { Pager, pageSlice } from '../components/ConnectionPanels';

const API = 'https://api.eighteen-media.id';

// Campaign = grup tujuan lintas platform (2026-10-08 YouTube; 2026-10-14 + TikTok & Instagram).
// Platform campaign menentukan anggota yang diatur dan angka yang dijumlah di ringkasan; saat memilih
// tujuan (UGC / upload Shorts) cukup klik nama campaign-nya.
const PLATFORM = [
  { id: 'youtube', label: 'YouTube', icon: 'ti-brand-youtube' },
  { id: 'tiktok', label: 'TikTok', icon: 'ti-brand-tiktok' },
  { id: 'instagram', label: 'Instagram', icon: 'ti-brand-instagram' },
];
function PlatformChecks({ value, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {PLATFORM.map(p => {
        const on = value.includes(p.id);
        return (
          <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 13,
            border: `1.5px solid ${on ? colors.accent : colors.border}`, background: on ? colors.accentMuted : colors.bgCardMuted, color: colors.textPrimary }}>
            <input type="checkbox" checked={on} onChange={() => onChange(on ? value.filter(x => x !== p.id) : PLATFORM.map(x => x.id).filter(x => x === p.id || value.includes(x)))}
              style={{ width: 15, height: 15, margin: 0 }} />
            <i className={`ti ${p.icon}`} style={{ fontSize: 15 }}></i>{p.label}
          </label>
        );
      })}
    </div>
  );
}

// Editor anggota akun TikTok / Instagram (pola sama dengan ChannelEditor).
function AccountEditor({ campaign, kind, all, initial, onSaved, onCancel }) {
  const [sel, setSel] = useState(() => new Set(initial));
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const save = async () => {
    setBusy(true); setErr('');
    try { await axios.put(`${API}/api/campaigns/${campaign.id}/accounts`, { [kind === 'tiktok' ? 'tiktok_ids' : 'ig_ids']: [...sel] }); onSaved(); }
    catch (e) { setErr(e.response?.data?.error || 'Gagal menyimpan'); }
    setBusy(false);
  };
  return (
    <div style={{ background: colors.bgCardMuted, border: `1px solid ${colors.border}`, borderRadius: radius.md, padding: 12, marginTop: 10 }}>
      {all.length === 0 ? (
        <div style={{ fontSize: 12, color: colors.textSecondary }}>Belum ada akun {kind === 'tiktok' ? 'TikTok' : 'Instagram'} yang terhubung. Hubungkan dulu di menu Hubungkan channel.</div>
      ) : all.map(a => (
        <label key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '7px 4px', borderTop: `1px solid ${colors.border}`, cursor: 'pointer', fontSize: 13, color: colors.textPrimary }}>
          <input type="checkbox" checked={sel.has(a.id)} onChange={() => setSel(prev => { const n = new Set(prev); n.has(a.id) ? n.delete(a.id) : n.add(a.id); return n; })} style={{ width: 15, height: 15, margin: 0, flex: '0 0 auto' }} />
          <span style={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>@{a.username || a.display_name}</span>
          {a.needs_reconnect && <span style={{ fontSize: 10, color: colors.danger }}>perlu reconnect</span>}
        </label>
      ))}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
        <button className="btn btn-gold" style={{ fontSize: 12 }} disabled={busy || all.length === 0} onClick={save}>{busy ? 'Menyimpan...' : `Simpan ${sel.size} akun`}</button>
        <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={onCancel}>Batal</button>
        {err && <span style={{ fontSize: 12, color: colors.danger }}>{err}</span>}
      </div>
    </div>
  );
}
const fmtNum = n => { n = Number(n || 0); return n >= 1e6 ? (n / 1e6).toFixed(1).replace('.', ',') + ' jt' : n >= 1e3 ? (n / 1e3).toFixed(1).replace('.', ',') + ' rb' : String(n); };
const ago = iso => {
  if (!iso) return 'belum ada';
  const m = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 60) return `${m} menit lalu`; const h = Math.floor(m / 60); if (h < 24) return `${h} jam lalu`; return `${Math.floor(h / 24)} hari lalu`;
};

function ChannelEditor({ campaign, allChannels, initial, onSaved, onCancel }) {
  const [sel, setSel] = useState(() => new Set(initial));
  const [q, setQ] = useState('');
  const [page, setPage] = useState(1);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const filtered = allChannels.filter(c => !q || (c.channel_name || '').toLowerCase().includes(q.toLowerCase()));
  const allOn = filtered.length > 0 && filtered.every(c => sel.has(c.id));
  const toggle = id => setSel(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const save = async () => {
    setBusy(true); setErr('');
    try { await axios.put(`${API}/api/campaigns/${campaign.id}/channels`, { channel_ids: [...sel] }); onSaved(); }
    catch (e) { setErr(e.response?.data?.error || 'Gagal menyimpan'); }
    setBusy(false);
  };
  return (
    <div style={{ background: colors.bgCardMuted, border: `1px solid ${colors.border}`, borderRadius: radius.md, padding: 12, marginTop: 10 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 8 }}>
        <input value={q} onChange={e => { setQ(e.target.value); setPage(1); }} placeholder="Cari nama channel..." style={{ flex: '1 1 200px', fontSize: 13 }} />
        <span onClick={() => setSel(prev => { const n = new Set(prev); filtered.forEach(c => allOn ? n.delete(c.id) : n.add(c.id)); return n; })}
          style={{ fontSize: 12, color: colors.accent, cursor: 'pointer', whiteSpace: 'nowrap' }}>{allOn ? 'Lepas semua hasil' : `Pilih semua hasil (${filtered.length})`}</span>
      </div>
      {pageSlice(filtered, page).map(c => (
        <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 9, padding: '7px 4px', borderTop: `1px solid ${colors.border}`, cursor: 'pointer', fontSize: 13, color: colors.textPrimary }}>
          <input type="checkbox" checked={sel.has(c.id)} onChange={() => toggle(c.id)} style={{ width: 15, height: 15, margin: 0, flex: '0 0 auto' }} />
          <span style={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>{c.channel_name}</span>
          {c.needs_reconnect && <span style={{ fontSize: 10, color: colors.danger }}>perlu reconnect</span>}
        </label>
      ))}
      <Pager total={filtered.length} page={page} onChange={setPage} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
        <button className="btn btn-gold" style={{ fontSize: 12 }} disabled={busy} onClick={save}>{busy ? 'Menyimpan...' : `Simpan ${sel.size} channel`}</button>
        <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={onCancel}>Batal</button>
        {err && <span style={{ fontSize: 12, color: colors.danger }}>{err}</span>}
      </div>
    </div>
  );
}

export default function Campaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [artists, setArtists] = useState([]);
  const [allChannels, setAllChannels] = useState([]);
  const [allTt, setAllTt] = useState([]);
  const [allIg, setAllIg] = useState([]);
  const [platEdit, setPlatEdit] = useState({}); // campaignId -> platform yang sedang diubah
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [form, setForm] = useState({ name: '', description: '', artist_id: '', platforms: ['youtube'] });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [campaignDetail, setCampaignDetail] = useState({});
  const [editing, setEditing] = useState(null);
  const [chPage, setChPage] = useState(1);

  const fetchCampaigns = async () => {
    setLoading(true);
    try { const res = await axios.get(`${API}/api/campaigns`); setCampaigns(res.data || []); }
    catch (e) { setError('Gagal memuat daftar campaign'); }
    setLoading(false);
  };
  const loadDetail = async (id) => {
    try { const res = await axios.get(`${API}/api/campaigns/${id}`); setCampaignDetail(prev => ({ ...prev, [id]: res.data })); }
    catch (e) { setError('Gagal memuat detail campaign'); }
  };

  useEffect(() => {
    fetchCampaigns();
    axios.get(`${API}/api/artists`).then(r => setArtists(r.data || [])).catch(() => {});
    axios.get(`${API}/api/youtube/channels`).then(r => setAllChannels((r.data || []).sort((a, b) => (a.channel_name || '').localeCompare(b.channel_name || '')))).catch(() => {});
    axios.get(`${API}/api/branding/tiktok`).then(r => setAllTt((r.data || []).filter(a => a.is_active !== false))).catch(() => {});
    axios.get(`${API}/api/branding/instagram/accounts`).then(r => setAllIg((r.data || []).filter(a => a.is_active !== false))).catch(() => {});
  }, []);

  const createCampaign = async () => {
    if (!form.name.trim()) return;
    setSaving(true); setError('');
    try {
      const r = await axios.post(`${API}/api/campaigns`, { name: form.name.trim(), description: form.description.trim() || null, artist_id: form.artist_id || null, platforms: form.platforms });
      setForm({ name: '', description: '', artist_id: '', platforms: ['youtube'] });
      setShowAddModal(false);
      await fetchCampaigns();
      // Langsung buka editor anggota platform pertama yang dipilih.
      if (r.data && r.data.id) { setExpandedId(r.data.id); await loadDetail(r.data.id); setEditing(`${r.data.id}:${(r.data.platforms || ['youtube'])[0]}`); }
    } catch (e) {
      setError(e.response?.data?.error || 'Gagal membuat campaign');
    }
    setSaving(false);
  };

  const simpanPlatform = async (c) => {
    const pl = platEdit[c.id];
    if (!pl || !pl.length) return;
    try { await axios.put(`${API}/api/campaigns/${c.id}`, { platforms: pl }); setPlatEdit(p => { const n = { ...p }; delete n[c.id]; return n; }); await fetchCampaigns(); await loadDetail(c.id); }
    catch (e) { setError(e.response?.data?.error || 'Gagal mengubah platform'); }
  };

  const deleteCampaign = async (id, name) => {
    if (!window.confirm(`Hapus campaign "${name}"? Channel, akun, dan video tidak ikut terhapus, hanya grupnya.`)) return;
    try { await axios.delete(`${API}/api/campaigns/${id}`); fetchCampaigns(); }
    catch (e) { setError('Gagal menghapus campaign'); }
  };

  const toggleExpand = async (id) => {
    if (expandedId === id) { setExpandedId(null); return; }
    setExpandedId(id); setEditing(null); setChPage(1);
    if (!campaignDetail[id]) await loadDetail(id);
  };

  const statusColor = (status) => {
    if (status === 'done') return colors.success;
    if (status === 'failed' || status === 'rejected') return colors.danger;
    if (status === 'awaiting_approval') return colors.warning;
    return colors.accent;
  };
  const stat = (label, value, color, sub) => (
    <div style={{ background: colors.bgCardMuted, borderRadius: radius.md, padding: '6px 10px', minWidth: 92 }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: color || colors.textPrimary }}>{value}</div>
      <div style={{ fontSize: 10, color: colors.textSecondary }}>{label}</div>
      {sub && <div style={{ fontSize: 10, color: colors.textSecondary, marginTop: 2, whiteSpace: 'nowrap' }}>{sub}</div>}
    </div>
  );
  // Pecahan Shorts (repost) vs UGC (2026-10-09).
  const pecah = (shorts, ugc) => `Shorts ${fmtNum(shorts || 0)} · UGC ${fmtNum(ugc || 0)}`;

  return (
    <div style={{ paddingBottom: 40 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 8 }}>
            <i className="ti ti-rocket" style={{ fontSize: 22 }}></i>Campaign
          </h1>
          <p style={{ fontSize: 13, color: colors.textSecondary, marginTop: 2 }}>Kelompokkan channel YouTube, akun TikTok, dan akun Instagram jadi grup. Pilih platform campaign: angka ringkasan hanya menjumlah platform yang dipilih. Saat upload, cukup klik nama campaign — anggotanya langsung tercentang.</p>
        </div>
        <button onClick={() => setShowAddModal(true)} className="btn btn-gold" style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
          <i className="ti ti-plus" style={{ fontSize: 15 }}></i>Buat Campaign
        </button>
      </div>

      {error && (
        <div style={{ padding: '10px 14px', background: colors.dangerMuted, color: colors.danger, borderRadius: radius.md, marginBottom: 16, fontSize: 13 }}>{error}</div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: colors.textSecondary }}>Memuat campaign...</div>
      ) : campaigns.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: colors.textSecondary, background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg }}>
          <i className="ti ti-rocket-off" style={{ fontSize: 40, marginBottom: 10, display: 'block' }}></i>
          Belum ada campaign. Klik "Buat Campaign", pilih platformnya, lalu masukkan channel/akun ke dalamnya.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {campaigns.map(c => {
            const d = campaignDetail[c.id];
            return (
            <div key={c.id} style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, overflow: 'hidden' }}>
              <div onClick={() => toggleExpand(c.id)} style={{ padding: 16, cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <i className={`ti ${expandedId === c.id ? 'ti-chevron-down' : 'ti-chevron-right'}`} style={{ fontSize: 16, color: colors.textSecondary }}></i>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: colors.textPrimary, overflowWrap: 'anywhere' }}>{c.name}</div>
                    <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 2, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                      {PLATFORM.filter(p => (c.platforms || ['youtube']).includes(p.id)).map(p => (
                        <span key={p.id} style={{ display: 'inline-flex', alignItems: 'center', gap: 3, padding: '1px 7px', borderRadius: 999, background: colors.accentMuted, color: colors.accentText, fontWeight: 600 }}>
                          <i className={`ti ${p.icon}`}></i>{p.label}
                        </span>
                      ))}
                      <span>{c.artist_name ? `${c.artist_name} · ` : ''}posting terakhir {ago(c.last_any_at)}</span>
                    </div>
                  </div>
                  <button onClick={(e) => { e.stopPropagation(); deleteCampaign(c.id, c.name); }} title="Hapus campaign" style={{ background: 'transparent', border: 'none', color: colors.textSecondary, cursor: 'pointer', padding: 4 }}>
                    <i className="ti ti-trash" style={{ fontSize: 16 }}></i>
                  </button>
                </div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10, paddingLeft: 28 }}>
                  {(() => {
                    const pl = c.platforms || ['youtube'];
                    const yt = pl.includes('youtube'), tt = pl.includes('tiktok'), ig = pl.includes('instagram');
                    const rinci = [yt && `YT ${fmtNum(c.uploads)}`, tt && `TT ${fmtNum(c.tt_posts)}`, ig && `IG ${fmtNum(c.ig_posts)}`].filter(Boolean).join(' · ');
                    const reconnect = (yt ? c.needs_reconnect || 0 : 0) + (tt ? c.tt_reconnect || 0 : 0);
                    return (<>
                      {stat('total konten terposting', fmtNum(c.total_uploads), null, pl.length > 1 ? rinci : (yt ? pecah(c.uploads_shorts, c.uploads_ugc) : null))}
                      {stat('posting 7 hari', fmtNum(c.total_uploads_7d))}
                      {yt && stat('channel YouTube', c.channels || 0)}
                      {tt && stat('akun TikTok', c.tt_accounts || 0)}
                      {ig && stat('akun Instagram', c.ig_accounts || 0)}
                      {stat('perlu reconnect', reconnect, reconnect > 0 ? colors.danger : colors.textSecondary)}
                      {yt && stat('views YouTube', fmtNum(c.views), null, pecah(c.views_shorts, c.views_ugc))}
                    </>);
                  })()}
                </div>
              </div>
              {expandedId === c.id && (
                <div style={{ padding: '0 16px 16px', borderTop: `1px solid ${colors.border}` }}>
                  {c.description && <p style={{ fontSize: 12, color: colors.textSecondary, marginTop: 12 }}>{c.description}</p>}
                  {!d ? (
                    <div style={{ fontSize: 12, color: colors.textSecondary, padding: '12px 0' }}>Memuat...</div>
                  ) : (
                    <>
                      <div style={{ marginTop: 12 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, marginBottom: 6 }}>Platform campaign</div>
                        <PlatformChecks value={platEdit[c.id] || c.platforms || ['youtube']} onChange={v => setPlatEdit(p => ({ ...p, [c.id]: v }))} />
                        {platEdit[c.id] && (
                          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8, flexWrap: 'wrap' }}>
                            <button className="btn btn-gold" style={{ fontSize: 12 }} disabled={!platEdit[c.id].length} onClick={() => simpanPlatform(c)}>Simpan platform</button>
                            <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={() => setPlatEdit(p => { const n = { ...p }; delete n[c.id]; return n; })}>Batal</button>
                            {!platEdit[c.id].length && <span style={{ fontSize: 12, color: colors.danger }}>Pilih minimal satu platform.</span>}
                            <span style={{ fontSize: 11, color: colors.textSecondary }}>Anggota platform yang dimatikan tidak dihapus, hanya tidak dihitung dan tidak ikut tercentang.</span>
                          </div>
                        )}
                      </div>
                      {(c.platforms || ['youtube']).includes('tiktok') && (
                        <div style={{ marginTop: 16 }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 6 }}><i className="ti ti-brand-tiktok"></i>Akun TikTok ({(d.tiktok_accounts || []).length})</div>
                            {editing !== `${c.id}:tiktok` && <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={() => setEditing(`${c.id}:tiktok`)}>Atur akun TikTok</button>}
                          </div>
                          {editing === `${c.id}:tiktok` && (
                            <AccountEditor campaign={c} kind="tiktok" all={allTt} initial={(d.tiktok_accounts || []).map(x => x.id)}
                              onCancel={() => setEditing(null)} onSaved={async () => { setEditing(null); await loadDetail(c.id); fetchCampaigns(); }} />
                          )}
                          {(d.tiktok_accounts || []).length === 0 ? <div style={{ fontSize: 12, color: colors.textSecondary, padding: '8px 0' }}>Belum ada akun TikTok di campaign ini.</div>
                            : (d.tiktok_accounts || []).map(a => (
                              <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: `1px solid ${colors.border}`, fontSize: 12 }}>
                                <span style={{ flex: 1, minWidth: 0, color: colors.textPrimary, overflowWrap: 'anywhere' }}>@{a.username || a.display_name}</span>
                                {a.needs_reconnect && <span style={{ fontSize: 10, fontWeight: 700, color: colors.danger }}>perlu reconnect</span>}
                                <span style={{ color: colors.textSecondary }}>{a.posts} video · terakhir {ago(a.last_post)}</span>
                              </div>
                            ))}
                        </div>
                      )}
                      {(c.platforms || ['youtube']).includes('instagram') && (
                        <div style={{ marginTop: 16 }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 6 }}><i className="ti ti-brand-instagram"></i>Akun Instagram ({(d.ig_accounts || []).length})</div>
                            {editing !== `${c.id}:instagram` && <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={() => setEditing(`${c.id}:instagram`)}>Atur akun Instagram</button>}
                          </div>
                          {editing === `${c.id}:instagram` && (
                            <AccountEditor campaign={c} kind="instagram" all={allIg} initial={(d.ig_accounts || []).map(x => x.id)}
                              onCancel={() => setEditing(null)} onSaved={async () => { setEditing(null); await loadDetail(c.id); fetchCampaigns(); }} />
                          )}
                          {(d.ig_accounts || []).length === 0 ? <div style={{ fontSize: 12, color: colors.textSecondary, padding: '8px 0' }}>Belum ada akun Instagram di campaign ini.</div>
                            : (d.ig_accounts || []).map(a => (
                              <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: `1px solid ${colors.border}`, fontSize: 12 }}>
                                <span style={{ flex: 1, minWidth: 0, color: colors.textPrimary, overflowWrap: 'anywhere' }}>@{a.username || a.display_name}</span>
                                <span style={{ color: colors.textSecondary }}>{a.posts} posting · terakhir {ago(a.last_post)}</span>
                              </div>
                            ))}
                        </div>
                      )}
                      {(c.platforms || ['youtube']).includes('youtube') && (<>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 16, gap: 8, flexWrap: 'wrap' }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 6 }}><i className="ti ti-brand-youtube"></i>Channel YouTube ({d.channels.length})</div>
                        {editing !== `${c.id}:youtube` && <button className="btn btn-outline" style={{ fontSize: 12 }} onClick={() => setEditing(`${c.id}:youtube`)}>Atur channel</button>}
                      </div>
                      {editing === `${c.id}:youtube` && (
                        <ChannelEditor campaign={c} allChannels={allChannels} initial={d.channels.map(x => x.id)}
                          onCancel={() => setEditing(null)}
                          onSaved={async () => { setEditing(null); await loadDetail(c.id); fetchCampaigns(); }} />
                      )}
                      {d.channels.length === 0 ? (
                        <div style={{ fontSize: 12, color: colors.textSecondary, padding: '10px 0' }}>Belum ada channel. Klik "Atur channel" untuk memasukkan channel ke campaign ini.</div>
                      ) : (
                        <div style={{ marginTop: 6 }}>
                          {pageSlice(d.channels, chPage).map(ch => (
                            <div key={ch.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: `1px solid ${colors.border}`, fontSize: 12 }}>
                              <span style={{ flex: 1, minWidth: 0, color: colors.textPrimary, overflowWrap: 'anywhere' }}>{ch.channel_name}</span>
                              {ch.needs_reconnect && <span style={{ fontSize: 10, fontWeight: 700, color: colors.danger }}>perlu reconnect</span>}
                              <span style={{ color: colors.textSecondary, textAlign: 'right' }}>{fmtNum(ch.views)} views · {ch.uploads} video<br /><span style={{ fontSize: 10 }}>Shorts {ch.uploads_shorts || 0} ({fmtNum(ch.views_shorts)} views) · UGC {ch.uploads_ugc || 0} ({fmtNum(ch.views_ugc)} views)</span></span>
                            </div>
                          ))}
                          <Pager total={d.channels.length} page={chPage} onChange={setChPage} />
                        </div>
                      )}
                      </>)}
                      <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, marginTop: 16 }}>Konten yang dijalankan lewat campaign ini</div>
                      {(d.ugc.length + d.jobs.length) === 0 ? (
                        <div style={{ fontSize: 12, color: colors.textSecondary, padding: '8px 0' }}>Belum ada. Saat memilih channel tujuan, klik nama campaign ini — kontennya akan tercatat di sini.</div>
                      ) : (
                        <div style={{ marginTop: 6 }}>
                          {d.ugc.map(u => (
                            <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', borderBottom: `1px solid ${colors.border}` }}>
                              <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 6, background: colors.accentMuted, color: colors.accent }}>UGC</span>
                              <span style={{ fontSize: 12, color: colors.textPrimary, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.title || 'Proyek UGC'}</span>
                              <span style={{ fontSize: 11, color: colors.textSecondary, whiteSpace: 'nowrap' }}>{u.uploaded} channel</span>
                            </div>
                          ))}
                          {d.jobs.map(j => (
                            <div key={j.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: '8px 0', borderBottom: `1px solid ${colors.border}` }}>
                              <span style={{ fontSize: 12, color: colors.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{j.title || 'Tanpa judul'}</span>
                              <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 6, background: statusColor(j.status) + '22', color: statusColor(j.status) }}>{j.status}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          ); })}
        </div>
      )}

      {showAddModal && (
        <div onClick={() => setShowAddModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: colors.bgCard, borderRadius: radius.lg, padding: 24, maxWidth: 400, width: '100%' }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: colors.textPrimary, marginBottom: 16 }}>Buat Campaign Baru</h2>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Nama Campaign</label>
              <input type="text" placeholder="Contoh: Rilis Single - Rindu Ini" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={{ width: '100%' }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Platform campaign</label>
              <PlatformChecks value={form.platforms} onChange={v => setForm({ ...form, platforms: v })} />
              <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 6 }}>Centang semua untuk campaign lintas platform, atau satu saja. Angka ringkasan hanya menghitung platform yang dicentang.</div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Artis (opsional)</label>
              <select value={form.artist_id} onChange={e => setForm({ ...form, artist_id: e.target.value })} style={{ width: '100%' }}>
                <option value="">-- Tidak ditentukan --</option>
                {artists.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Deskripsi (opsional)</label>
              <textarea placeholder="Catatan tentang campaign ini..." value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                style={{ width: '100%', minHeight: 60, background: colors.bgCardMuted, border: `1px solid ${colors.border}`, borderRadius: 8, color: colors.textPrimary, padding: '8px 12px', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setShowAddModal(false)} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: `1px solid ${colors.borderStrong}`, background: colors.bgCard, color: colors.textPrimary, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Batal</button>
              <button onClick={createCampaign} disabled={saving || !form.name.trim() || !form.platforms.length} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: (saving || !form.name.trim() || !form.platforms.length) ? colors.border : colors.accent, color: '#FFFFFF', fontSize: 13, fontWeight: 700, cursor: (saving || !form.name.trim()) ? 'not-allowed' : 'pointer' }}>{saving ? 'Menyimpan...' : 'Simpan'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
